import { render, staticRenderFns } from "./SettingsProducerModal.vue?vue&type=template&id=4184cb73&"
import script from "./SettingsProducerModal.vue?vue&type=script&lang=js&"
export * from "./SettingsProducerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports